import { useSelector } from "react-redux";
import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import Toggle from "src/components/toggles/Toggle";
import { hasEditAccess } from "src/redux/selectors/app";
import ActionsCell from "./ActionsCell";
import { MembershipType } from "./memberships-types";

const useMembershipTableColumns = ({
  onDelete,
  handleMembershipStatusChange,
}: {
  onDelete: (id: number) => void;
  handleMembershipStatusChange: (membershipId: number, status: boolean) => void;
}) => {
  const hasEditPermission = useSelector(hasEditAccess);

  return [
    {
      Header: "Membership Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Duration",
      accessor: "duration",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<MembershipType>) => {
        return <TextCell value={value ?? 0} />;
      },
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Membership Credit",
      accessor: "credit",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Commission",
      accessor: "commission",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<MembershipType>) => {
        return (
          <div className="flex justify-center">
            <Toggle
              checked={value}
              onToggle={(value) =>
                handleMembershipStatusChange(row.original.id, value)
              }
              disabled={!hasEditPermission}
              tooltip={
                hasEditPermission ? "" : "You don't have permission to edit."
              }
              showToggleStatus
            />
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<MembershipType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useMembershipTableColumns;
